<template>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-left">{{$t('process.processType')}}</h2>

        <LayoutCard :title="$t('general.informations')" active="true">
          <div class="loader" v-if="loading">

          </div>

          <fieldset :disabled="loading">
            <form @change="save()">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="inputName">{{ $t('general.name') }}</label>
                  <b-form-input v-can:input="'Update_FormulaProcessType'" type="text" class="form-control" :state="validateState($v.objectData.name)" id="inputName" :placeholder="$t('process.processType')" :lazy="true" :trim="true" v-model="$v.objectData.name.$model" />
                  <div class="invalid-feedback" id="company-name-required" v-if="!$v.objectData.name.required">{{$t('errorMsg.required')}}</div>
                </div>
              </div>
            </form>
          </fieldset>

        </LayoutCard>

        <LayoutCard :title="$tc('process.template', 1)" active="true">

          <div>

            <EditableGridJson :array="processItems" permission="Update_FormulaProcessType" :value.sync="processItems" @edited="save()" :key="objectData.dataTemplate"></EditableGridJson>

          </div>

        </LayoutCard>

        <div v-if="isMod">
          <SaveCancelDeleteButtons permission="Create_FormulaProcessType" @clicked="getClicked" @isMod="isMod" :isError="$v.$anyError"></SaveCancelDeleteButtons>
        </div>

        <div class="fixed-top mt-3 d-flex justify-content-center">
          <b-alert :show="dismissCountDown" dismissible fade :variant="alertType" @dismiss-count-down="countDownChanged">
            {{ feedbackMessage }}
          </b-alert>
        </div>

      </div>
    </div>
  </div>

</div>
</template>

<script>
import axios from 'axios'
import LayoutCard from '../components/LayoutCard.vue'
import SaveCancelDeleteButtons from '../components/SaveCancelDeleteButtons.vue'
import EditableGridJson from '../components/EditableGridJson.vue'

import Feedback from '../mixins/Feedback.js'
import CommonVariablesAndFunctions from '../mixins/CommonVariablesAndFunctions.js'
import {
  required
} from 'vuelidate/lib/validators'

window.axios = require("axios");

export default {
  name: 'processType',

  mixins: [Feedback, CommonVariablesAndFunctions],

  components: {
    LayoutCard,
    EditableGridJson,
    SaveCancelDeleteButtons,
  },

  data() {
    return {
      title: "processType",
      endpoint: "formulaProcessType",
      value: "",

      objectData: {
        addBy: "",
        addDate: "",
        modBy: "",
        modDate: null,
        name: "",
        dataTemplate: ""
      },

      processItems: [
        ["Phase", "Operation", "Time"],
        ["", "", ""],
      ],

    };
  },
  methods: {

    processForm() {

      let processTemplateStringify = JSON.stringify(this.processItems);

      let processType = {
        name: this.objectData.name,
        dataTemplate: processTemplateStringify

      };
      return processType

    },

    async getData() {
      this.loading = true;

      let response = await axios.get(this.endpoint + '/' + this.$route.params.id)
      this.objectData = response.data
      console.log(this.objectData);

      this.processItems = JSON.parse(response.data.dataTemplate)

      this.loading = false;
      this.isMod = false;
    },

    postData(endpoint, data) {
      axios
        .post(endpoint, data)
        .then((response) => {
          this.isMod = false
          this.succesAlert()
          let id = response.data._links.self.href.split("/").pop();
          this.$router.push('setup-process-type/' + id);
        })
        .catch((error) => {
          this.errorAlert(error)
        })
    },

    putData(endpoint, data) {
      axios
        .put(endpoint, data)
        .then(() => {
          this.isMod = false
          this.succesAlert()
        })
        .catch((error) => {
          this.errorAlert(error)
        })
    },

  },

  created() {
    if (this.$route.params.id) {
      this.getData();
    } else {
      this.loading = false;
    }
  },

  validations: {

    objectData: {
      name: {
        required,
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  text-align: left;
  font-weight: bold;
}
</style>
